export default __webpack_public_path__ + "static/char-v-57-zh-Hant-244aa15e6e5b49baebdf0ee8ab176ea1.mp4";